import { debounce } from 'lodash-es';
import { useEffect, useMemo, useRef } from 'react';

type DebounceSettings = Parameters<typeof debounce>[2];

/**
 * A debounced callback for React
 */
export function useDebounceCallback<C extends (...args: any) => any>(
  callback: C,
  delay: number,
  options?: DebounceSettings,
) {
  const callbackRef = useRef(callback);
  callbackRef.current = callback;

  const debouncedCallback = useMemo(() => {
    return debounce((...args: any[]) => callbackRef.current(...args), delay, options);
  }, [delay, options]);

  // Cleanup to cancel debounce on unmount
  useEffect(() => {
    return () => debouncedCallback.cancel();
  }, [debouncedCallback]);

  return debouncedCallback as unknown as C;
}
